const state = {
  id: undefined,
  owner_id: undefined,
  owner_type: '',
  recipient_id: undefined,
  recipient_type: '',
  subject_id: undefined,
  subject_type: '',
  title: '',
  url: '',
}

export const requiredFields = [
  { key: 'owner_id' },
  { key: 'owner_type' },
  { key: 'recipient_id' },
  { key: 'recipient_type' },
  { key: 'subject_id' },
  { key: 'subject_type' },
  { key: 'title' },
  { key: 'url' },
]

export default state
